import React from "react";

import { cn } from "@/lib/utils";
import obj from "@/utils/obj";

import { useTabsContext } from "./Tabs";

//

export interface TabsPanelProps {
  className?: string;
}

//

export const TabsPanel: React.FC<TabsPanelProps> = ({ className }) => {
  const tabs = useTabsContext((s) => s.tabs);

  return (
    <div
      className={cn(
        "bg-muted text-muted-foreground inline-flex h-9 items-center justify-center rounded-lg p-1",
        className,
      )}
    >
      {obj.entries(tabs).map(({ key, value }, i) => (
        <TabTrigger key={String(key)} id={key.toString()}>
          {value.title ?? `Tab ${i + 1}`}
        </TabTrigger>
      ))}
    </div>
  );
};

//

interface TabTriggerProps {
  children?: React.ReactNode;
  className?: string;
  id: string;
}

const TabTrigger: React.FC<TabTriggerProps> = ({ children, className, id }) => {
  const currentTabId = useTabsContext((s) => s.tab.id);
  const active = currentTabId === id;
  const setTab = useTabsContext((s) => s.setTab);

  return (
    <button
      className={cn(
        "ring-offset-background focus-visible:ring-ring data-[state=active]:bg-background data-[state=active]:text-foreground inline-flex items-center justify-center rounded-md px-3 py-1 text-sm font-medium whitespace-nowrap transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm",
        className,
      )}
      data-state={active && "active"}
      onClick={() => setTab(id)}
    >
      {children}
    </button>
  );
};
